import { useQuery } from 'react-query';
import { getAirportList } from '@/api';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { AirportListResponse } from '@/types/common.type';

const useGetAirportList = (passportNumber: string | null) => {
  const dispatch = useAppDispatch();

  return useQuery(
    ['airportList'],
    () => (!!passportNumber ? getAirportList({ passportNumber }) : null),
    {
      onSuccess: (data: AirportListResponse) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            hasTakeOutNumber: data.hasTakeOutNumber,
          },
        });
      },
      enabled: !!passportNumber,
    },
  );
};

export default useGetAirportList;
